import { render, staticRenderFns } from "./twitter.vue?vue&type=template&id=62623588&scoped=true&"
var script = {}
import style0 from "./twitter.vue?vue&type=style&index=0&id=62623588&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62623588",
  null
  
)

export default component.exports